import { Button, Grid, Group, Paper, Title } from '@mantine/core';
import { useMutation, useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { dashboardApi } from '../../data-access/api/dashboard.api';

import styles from './statistics-header.module.css';

import { FORM_STATUS, useSharedQueries } from '@data-access';

export function StatisticsHeader() {
  const { t } = useTranslation();
  const [computationRequestId, setComputationRequestId] = useState<
    number | null
  >(null);

  const exportStats = useMutation({
    mutationFn: dashboardApi.exportStats,
    onSuccess: (data) => {
      setComputationRequestId(data.instance_id);
    },
  });
  const downloadExport = useMutation({
    mutationFn: dashboardApi.downloadExport,
  });
  const sharedQueries = useSharedQueries();
  const computationRequest = useQuery({
    ...sharedQueries.computationRequest({ id: computationRequestId! }),
    enabled: computationRequestId !== null,
  });

  useEffect(() => {
    if (computationRequest.data?.status === FORM_STATUS.FINISHED) {
      downloadExport.mutate({ id: computationRequest.data.id });
      setComputationRequestId(null);
    }
  }, [computationRequest.data, downloadExport]);

  return (
    <Paper>
      <Group justify="space-between">
        <Title order={2}>{t('statistics.title')}</Title>
        <Button
          loading={computationRequest.data?.status === FORM_STATUS.PENDING}
          onClick={() => {
            exportStats.mutate();
          }}
        >
          {t('statistics.export')}
        </Button>
      </Group>
    </Paper>
  );
}

export default StatisticsHeader;
